import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEmpty, noop, map } from "lodash";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { normalizeAmount } from "../../utils/transformer.util";
import {
  Button,
  Select,
  SearchSelect,
  SelectMultiple,
  Input,
  Textarea,
} from "../../components/base/index";

const MySwal = withReactContent(Swal);

export default class UnpostingTKSD extends Component {
  constructor(props) {
    super(props);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._onRemoveMulti = this._onRemoveMulti.bind(this);
    this._onChangeMulti = this._onChangeMulti.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this._getPrmStaffKepsekOptions = this._getPrmStaffKepsekOptions.bind(this);
    this._onAddList = this._onAddList.bind(this);
    this._onDeleteList = this._onDeleteList.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    this.unPosting = this.unPosting.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this._getPeriodsOptions = this._getPeriodsOptions.bind(this);
    this._getYears = this._getYears.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    this.state = {
      page: 1,
      filters: {},
      form: {
        value: {
          listUnposting: [],
          user_id: user.id,
        },
        error: {},
      },
      param: {},
      showModal: false, // untuk menampilkan modal
      activeData: null,
    };
  }

  componentDidMount() {
    const { location, getLevels, getclassrooms, user } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { school_unit, organizations_id } = user;
    const paramTypes = ["levels"];
    paramTypes.forEach((type) => {
      this._getParamOptionsAcademics(type);
    });

    if (isEdit && data) {
      this._setForm(data);
    }
    // this._getSchoolUnitsOptions();
    this._onSearchContent();
    this._getPrmStaffKepsekOptions();
    this._getYears({});
  }

  async _getPrmStaffKepsekOptions(filters = {}) {
    const { getPrmStaffKepsekOptions, user } = this.props;
    const { school_unit, user_group } = user;
    const { levels_id } = school_unit;
    const res = await getPrmStaffKepsekOptions(filters);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        staff: res,
      },
    }));
  }

  async _getPeriodsOptions(filters = {}) {
    const { getPeriodsOptions, user } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getPeriodsOptions(filters);

    map(res, (data, idx) => {
      const date = new Date();
      const start_date = new Date(data.attributes.start_date);
      if (date > start_date) {
        // tahun ajaran sekarang
        this.setState((prevState) => ({
          ...prevState,
          filters: {
            ...prevState.filters,
            period: data.label,
            period_id: data.value,
          },
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              period_id: data.value,
            },
          },
        }));
      }
    });

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        periods: res,
      },
    }));
  }

  async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { school_unit, organizations_id } = user;
    if (type === "classrooms" || type === "classrooms") {
      filters.organizations_id = organizations_id;
      // filters.units_id = school_unit.id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }
  // componentDidUpdate(prevProps) {
  //   // const { user } = this.props;
  //   // const { workingUnit } = user;
  //   // const { user: prevUser } = prevProps;
  //   // const { workingUnit: prevWorkingUnit } = prevUser;

  //   // if (!isEqual(workingUnit, prevWorkingUnit)) {
  //   //   this.handleGetData();
  //   // }
  //   if (!isEqual(prevProps, this.props)) {
  //     this._onSearchContent({ page: 1 });
  //   }
  // }

  async _setForm(data) {
    const { user } = this.props;
    const { organizations_id } = user;
    const { form } = this.state;
    // this._getSchoolUnitsOptions({ levels_id: data.levels_id });

    try {
      this.setState({
        form: {
          value: {
            id: data.id,
            min_student: data.min_student,
            max_student: data.max_student,
            jp: data.jp,
            kelmeng: data.kelmeng,
          },
          error: {},
        },
      });
    } catch (err) {
      // err action
    }
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    const { user } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    if (name === "user_groups_id") {
      this.setState((prevState) => ({
        filters: {
          ...prevState.filters,
          username: "",
        },
      }));
    }
    this.setState(
      (prevState) => ({
        ...prevState,
        filters: {
          ...prevState.filters,
          [name]: value,
        },
      }),
      () => {
        if (name === "perwakilan_id") {
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                perwakilan_id: value,
                units_id: "",
              },
            },
          }));
          this._getSchoolUnitsOptions({ perwakilan_id: value.value });
          // if(value.value == 'all'){
          // this._onSearchContent();
          // }
        }
        this._onSearchContent();
      }
    );
  }

  async onSubmit() {
    const { history, handleSaveParameterBK } = this.props;
    const { form } = this.state;
    const { value } = form;
    const { min_student, jp, kelmeng } = value;
    let canSaveA = false;

    if (min_student && jp && kelmeng) {
      canSaveA = true;
    } else {
      canSaveA = false;
    }
    if (canSaveA == false) {
      alert(
        "Harap lengkapi data form. Bagian yang harus diisi ditandai dengan tanda bintang (*)."
      );
    } else {
      await handleSaveParameterBK(value);
      history.push("/dashboard/pengaturan/parameter-bk");
      history.go(0);
    }
  }

  async onEdit() {
    const { history, handleEditParameterBK } = this.props;
    const { form } = this.state;
    const { value } = form;
    const { min_student, jp, kelmeng } = value;
    let canSaveA = false;

    if (min_student && jp && kelmeng) {
      canSaveA = true;
    } else {
      canSaveA = false;
    }
    if (canSaveA == false) {
      alert(
        "Harap lengkapi data form. Bagian yang harus diisi ditandai dengan tanda bintang (*)."
      );
    } else {
      await handleEditParameterBK(value);
      history.push("/dashboard/pengaturan/parameter-bk");
      history.go(0);
    }
  }

  _setIsBlocked(isBlocked) {
    const { form, filters, param } = this.state;
    const { value } = form;
    const { rombels, classes_id } = value;
    const newList = JSON.parse(JSON.stringify(rombels));
    newList.forEach((item) => {
      item.is_active = isBlocked;
    });

    this.setState((prevState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          rombels: newList,
        },
      },
    }));
  }

  async _onSearchContent(params = {}) {
    const { filters, param } = this.state;
    const savedFilters = JSON.parse(window.localStorage.getItem("param")) || "";
    const prm_usergroups = savedFilters.userGroups;

    console.log(filters);
    this.setState(async () => {
      try {
        const { handleListUnpostingTKSD, user } = this.props;
        const { school_unit, organizations_id } = user;
        const result = await handleListUnpostingTKSD({
          organizations_id,
          units_id: school_unit.id,
          period_name: filters.period_name,
        });
        this.setState((prevState) => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listUnposting: result,
            },
          },
        }));
      } catch (err) {
        // if (this.isMount) {
        this.setState((prevState) => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listUnposting: [],
            },
          },
        }));
      }
      // }
    });
  }

  _onFormChange(event) {
    const { form, param } = this.state;
    const { details } = form.value;
    const { user } = this.props;
    const { school_unit, organizations_id } = user;
    const { name, value, dataset, checked, type } = event.target;
    const {
      inputType = "text",
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;

    this.setState(
      (prevState) => {
        let newList = [];
        let newListError = [];
        let formattedValue = value;
        if (inputType === "number") {
          formattedValue = normalizeAmount(value);
        }
        if (inputArray) {
          if (type === "checkbox") {
            formattedValue = checked;
          }

          newList = [...(prevState.form.value[fieldName] || [])];
          newListError = [...(prevState.form.error[fieldName] || [])];

          // Inisialisasi jika belum ada
          if (!newList[arrayPosition]) {
            newList[arrayPosition] = {};
          }
          if (!newListError[arrayPosition]) {
            newListError[arrayPosition] = {};
          }

          newList[arrayPosition][name] = formattedValue;

          if (name === "code_of_account") {
            newList[arrayPosition].isCredit = value.type;
          }

          if (!isEmpty(newListError[arrayPosition])) {
            newListError[arrayPosition][name] = "";
          }
          console.log("Updated notes:", newList[arrayPosition][name]);
          console.log("Form state:", prevState.form.value.listUnposting);
        }
        return {
          form: {
            value: {
              ...prevState.form.value,
              ...(inputArray
                ? { [fieldName]: newList }
                : { [name]: formattedValue }),
            },
            error: {
              ...prevState.form.error,
              ...(inputArray ? { [fieldName]: newListError } : { [name]: "" }),
            },
          },
        };
      },
      () => {
        if (name === "classes_id") {
          const param = this.state.param.classes_prm;
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                // graduate: param.find(i => i.value == value).attributes.graduate,
              },
            },
          }));
        }
      }
    );
  }

  _onRemoveMulti(
    selectedList,
    removedItem,
    inputArray,
    fieldName,
    arrayPosition
  ) {
    this._onFormChange({
      target: {
        name: removedItem,
        value: selectedList,
        dataset: {
          inputArray,
          fieldName,
          arrayPosition,
        },
      },
    });
  }

  _onChangeMulti(value, name, inputArray, fieldName, arrayPosition) {
    this._onFormChange({
      target: {
        name,
        value,
        dataset: {
          inputArray,
          fieldName,
          arrayPosition,
        },
      },
    });
  }

  _onAddList(data) {
    const { form } = this.state;
    const { rombels } = form.value;

    rombels.push({
      min_rombel: "",
      max_rombel: "",
      min_headcount: "",
      details: [],
    });

    this.setState((prevState) => ({
      form: {
        value: {
          ...prevState.form.value,
          rombels,
        },
        error: {
          ...prevState.form.error,
        },
      },
    }));
  }

  async unPosting(val, notes) {
    const { handleUnpostingPosition } = this.props;
    const res = await handleUnpostingPosition({
      units_id: val.unit_code,
      period: val.name_period,
      notes: notes,
    });
    if (res) {
      this._onSearchContent();
    }
  }

  async onClickDelete(id) {
    const { history } = this.props;
    console.log(id);
    const { handleDeleteTeachSchedule, organizations_id } = this.props;
    const res = await handleDeleteTeachSchedule(id);
    if (res) {
      this._onSearchContent();
      // history.go(0);
    }
  }

  _onDeleteList(idx) {
    this.setState((prevState) => {
      const { rombels } = prevState.form.value;
      const list = prevState.form.value.rombels;

      list.splice(idx, 1);
      return {
        ...prevState,
        rombels: list,
      };
    });
  }
  _renderButtons(data) {
    const { user } = this.props;
    console.log(data.id);
    return (
      <td>
        <div className="table__actions">
          {data.is_posting == 1 ? (
            <Button
              onClick={() => this.openModalMethod(data)}
              title="Unposting"
            />
          ) : (
            ""
          )}
          {/* <Button onClick={() => this.onClickDelete(data)} title="Delete" /> */}
        </div>
      </td>
    );
  }

  // openModalMethod(data) {
  //   MySwal.fire({
  //     title: <p>Unposting Data</p>,
  //     width: "550px",
  //     html: this.renderModalContentMethod(data),
  //     showCancelButton: false,
  //     showConfirmButton: false,
  //   });
  // }

  openModalMethod(data) {
    console.log("Modal dibuka dengan data:", data); // 👈 Debug penting

    const { form } = this.state;
    const list = [...form.value.listUnposting];

    // Cari index data yang akan di-unposting
    const index = list.findIndex((item) => item.units_id === data.units_id);

    // Kosongkan notes-nya agar textarea tidak muncul value lama
    if (index !== -1) {
      list[index].notes = ""; // ✅ Reset field
    }

    this.setState({
      form: {
        ...form,
        value: {
          ...form.value,
          listUnposting: list,
        },
      },
      showModal: true,
      activeData: data,
      notesError: "", // juga reset pesan error kalau sebelumnya muncul
    });
  }

  onClickAdd() {
    const { history } = this.props;
    history.push("/dashboard/pengaturan/tambah-master-mapel", {
      // isEdit: true,
      // data: { units_id: units_id},
    });
  }

  renderCustomModal() {
    const { form, activeData } = this.state;
    const { listUnposting } = form.value;
    const index = form.value.listUnposting.findIndex(
      (i) => i.units_id === activeData.units_id
    );
    const notes =
      form.value.listUnposting[index] && form.value.listUnposting[index].notes;
    const notes_pop =
      form.value.listUnposting[index] &&
      form.value.listUnposting[index].notes_pop;

    console.log(notes_pop);

    // Inline style langsung di sini
    const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  overflowY: "auto", // biar bisa scroll kalau tinggi
  zIndex: 500,
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  padding: "6vh 0", // beri jarak atas bawah relatif terhadap tinggi layar
};

const modalContentStyle = {
  position: "relative",
  backgroundColor: "#fff",
  padding: "30px 20px",
  borderRadius: "10px",
  width: "400px",
  maxWidth: "90vw",
  textAlign: "center",
  boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
  marginTop: "130px",
  marginBottom: "10px",
};



    const textareaStyle = {
      width: "100%",
      height: "100px",
      marginTop: "10px",
      marginBottom: "20px",
      padding: "10px",
      fontSize: "14px",
      borderRadius: "5px",
      border: "1px solid #ccc",
      resize: "none",
    };

    const buttonWrapperStyle = {
      display: "flex",
      gap: "10px",
      justifyContent: "center",
      marginTop: "10px",
    };
    const formattedNotes = notes_pop
      ? notes_pop
          .map((item) => {
            const [date, time] = item.created_at.split(" ");
            return `${date}  ${item.notes_pop}\n${time}`;
          })
          .join("\n\n")
      : "";


    return (
      <div style={modalOverlayStyle}>
        <div style={modalContentStyle}>
          <h1 style={{ marginBottom: 5 }}>Unposting {activeData.name}</h1>
          <p style={{ fontSize: 14, color: "#444" }}>
            Periode: <strong>{activeData.name_period}</strong>
          </p>
          <div
            style={{
              backgroundColor: "#FEF3C7", // kuning muda
              border: "1px solid #FCD34D",
              borderRadius: "10px",
              padding: "5px",
              fontSize: "12px",
              color: "#4B5563",
              marginBottom: "5px",
              marginTop: "5px",
            }}
          >
            <Textarea
              name="notes"
              label="Catatan"
              placeholder="Pilihan"
              onChange={this._onChangeFilter}
              value={formattedNotes}
              readOnly
              style={{ height: "100px" }}
              // disabled
            />
          </div>
          <div style={{ marginBottom: "10px" }}>
            <p htmlFor="notes" style={{ display: "block", fontWeight: "bold" }}>
              Catatan <span style={{ color: "red" }}>*</span>
            </p>
            <textarea
              id="notes"
              name="notes"
              value={notes || ""}
              onChange={(e) => {
                const updatedList = [...this.state.form.value.listUnposting];
                updatedList[index] = {
                  ...updatedList[index],
                  notes: e.target.value,
                };
                this.setState((prevState) => ({
                  form: {
                    ...prevState.form,
                    value: {
                      ...prevState.form.value,
                      listUnposting: updatedList,
                    },
                  },
                }));
              }}
              rows="4"
              style={{
                width: "100%",
                padding: "8px",
                fontSize: "14px",
                border: this.state.notesError
                  ? "2px solid red"
                  : "1px solid #ccc",
                borderRadius: "4px",
                resize: "vertical",
              }}
              required
            />

            {this.state.notesError && (
              <p style={{ color: "red", fontSize: "13px", marginTop: "4px" }}>
                {this.state.notesError}
              </p>
            )}
          </div>

          <div style={buttonWrapperStyle}>
            <Button
              title="LANJUT"
              onClick={() => {
                var notesRaw =
                  this.state.form.value.listUnposting[index] &&
                  this.state.form.value.listUnposting[index].notes;

                var notesValue =
                  typeof notesRaw === "string" ? notesRaw.trim() : "";
                console.log(notesValue);

                if (notesValue === "") {
                  this.setState({ notesError: "Catatan wajib diisi." });
                  return;
                }

                this.setState({ notesError: "" }); // Clear error jika valid
                this.unPosting(activeData, notesValue);
                this.setState({ showModal: false });
              }}
            />

            <Button
              title="BATAL"
              onClick={() => this.setState({ showModal: false })}
            />
          </div>
        </div>
      </div>
    );
  }

  async _getYears() {
    const years = [];
    const thisyear = new Date().getFullYear();
    for (let i = 2021; i <= thisyear; i++) {
      const nextyear = Number(i) + 1;
      years.push({
        label: `${i}-${nextyear}`,
        value: `${i}-${nextyear}`,
      });
    }

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        periods: years,
        period:
          prevState.param && prevState.param.period
            ? prevState.param.period
            : thisyear,
      },
    }));
  }

  render() {
    const { location, getLevels, getclassrooms, user } = this.props;
    const { form, filters, param } = this.state;
    const { listUnposting } = form.value;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const dataGet = data || "";

    // const years = [];
    // const thisyear = new Date().getFullYear();
    // for (let i = 2021; i <= thisyear; i++) {
    //   const nextyear = Number(i) + 1;
    //   years.push({
    //     label: `${i}-${nextyear}`,
    //     value: i,
    //   });
    // }

    // console.log(thisyear)

    console.log(data);
    return (
      <div className="manage-registration">
        <h1>Unposting Struktur Jabatan TK SD</h1>
        <hr />
        <div className="absensi-rekap__custom-form">
          <div className="absensi-rekap__custom-form-row">
            <Select
              name="period_name"
              label="Tahun Ajaran"
              placeholder="Pilihan"
              onChange={this._onChangeFilter}
              data={param.periods}
              value={filters.period_name}
              // disabled
            />
          </div>
        </div>

        <div className="manage-registration">
          <div className="fund-request__content">
            <table className="table">
              <thead>
                <tr style={{ textAlign: "center" }}>
                  <th>No</th>
                  <th>Unit</th>
                  <th>Status</th>
                  <th>Opsi</th>
                </tr>
              </thead>
              <tbody>
                {map(listUnposting, (list, idx) => (
                  <tr key={`budget_row_${idx}`}>
                    <td style={{ textAlign: "center" }} key={`table_$${idx}`}>
                      {idx + 1}
                    </td>
                    <td key={`table_${idx}`} style={{ textAlign: "center" }}>
                      {list.name}
                    </td>
                    <td key={`table_${idx}`} style={{ textAlign: "center" }}>
                      {list.status}
                    </td>
                    {this._renderButtons(list)}
                  </tr>
                ))}
                {this.state.showModal && this.renderCustomModal()}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
UnpostingTKSD.propTypes = {
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
UnpostingTKSD.defaultProps = {
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
